@if (risk(); as risk) {
  @switch (risk | uppercase) {
    @case ('SEVERE') {
      <span
        class="flex items-center gap-1 rounded-[4px] leading-[1.2] text-[11px] py-[3px] px-2 w-max text-white bg-aml-red-800">
        <img ngSrc="assets/icons/icon-risk-severe.svg" alt="risk-severe" height="10" width="10">
        <span>Severe</span>
      </span>
    }
    @case ('HIGH') {
      <span
        class="flex items-center gap-1 rounded-[4px] leading-[1.2] text-[11px] py-[3px] px-2 w-max text-white bg-aml-red-100">
        <img ngSrc="assets/icons/icon-risk-high.svg" alt="risk-high" height="8" width="4">
        <span>High</span>
      </span>
    }
    @case ('MEDIUM') {
      <span
        class="flex items-center gap-1 rounded-[4px] leading-[1.2] text-[11px] py-[3px] px-2 w-max text-[#2D2D2D] bg-aml-yellow-100">
        <img ngSrc="assets/icons/icon-risk-medium.svg" alt="risk-medium" height="8" width="4">
        <span>Medium</span>
      </span>
    }
    @case ('LOW') {
      <span
        class="flex items-center gap-1 rounded-[4px] leading-[1.2] text-[11px] py-[3px] px-2 w-max text-white bg-aml-green-800">
        <img ngSrc="assets/icons/icon-risk-low.svg" alt="risk-low" height="8" width="9">
        <span>Low</span>
      </span>
    }
  }
} @else {
  {{ '---' }}
}
